/**
 * 9am design-system colors used across the refill surfaces (hub + home card),
 * consolidated so a token change is a single edit rather than a hunt across files.
 * Keys follow the Figma token names; values are the hexes previously duplicated in
 * RefillCard, RefillRequirementRow, CountdownRing and RefillHubProgress.
 *
 * NOTE: these are app-wide 9am tokens (still hardcoded elsewhere, e.g. ConsistencyScoreTile).
 * If an app-level design-token module is introduced later, fold these into it.
 */
export const RefillColors = {
  inRange: "#6FC696", // Primary/InRange
  sunriseOrange: "#FFBD70", // Primary/SunriseOrange
  mint: "#AFF2CE", // completion-gradient end
  cream: "#FFFCF3", // Primary/Cream — unfilled track
  criticalRed: "#FF7663", // Primary/criticalRed
  purpleHaze: "#C294FF", // Primary/PurpleHaze
  accessiblePurpleHaze: "#5F1F8F", // Accessible/PurpleHaze
  accessibleRed: "#D04734", // Accessible/Red
  accessibleGreen: "#0E843A", // Accessible/Green
  accessibleOrange: "#CA4727" // Accessible/Orange — overdue card
} as const;
